import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import styles from "./TemplateParts.module.scss";
// import BackButton from "./Backbutton";

const ThubBanner = ({
  mainTitle,
  subTitle,
  backUrl = "",
  backText = "Back to main menu",
}) => {
  const [text, setText] = useState("");

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const navigate = useNavigate();
  return (
    <div className={styles.bannerCont}>
      <Container>
        <div className="d-flex justify-content-between">
          <div className={styles.leftCont}>
            <h2 className="text-white">{mainTitle}</h2>
            {/* <p
              className="text-white mx-2"
              style={{ fontFamily: "Open Sans, sans-serif", wordSpacing: "2px" }}
            >
              {subTitle}
            </p> */}
          </div>
          <div className={styles.rightCont}>
            {/* <BackButton /> */}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ThubBanner;
